// Episode popularity metrics - Updated with actual YouTube view counts
// Last updated: 2026-01-25
// Source: YouTube channel @LennysPodcast

export interface EpisodePopularity {
  spotifyPlays?: number;
  youtubeViews?: number;
  estimatedPopularity?: number;
  lastUpdated?: string;
}

export const episodePopularity: Record<string, EpisodePopularity> = {
  ' Bosworth': {
    youtubeViews: 37576,
    lastUpdated: '2026-01-25',
  },
  'Aarthi': {
    youtubeViews: 6745,
    lastUpdated: '2026-01-25',
  },
  'Ada Chen Rekhi': {
    youtubeViews: 2020,
    lastUpdated: '2026-01-25',
  },
  'Adam Fishman': {
    youtubeViews: 5446,
    lastUpdated: '2026-01-25',
  },
  'Adam Grenier': {
    youtubeViews: 2999,
    lastUpdated: '2026-01-25',
  },
  'Aishwarya Naresh Reganti': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Albert Cheng': {
    youtubeViews: 22116,
    lastUpdated: '2026-01-25',
  },
  'Alex Hardiman': {
    youtubeViews: 6781,
    lastUpdated: '2026-01-25',
  },
  'Alex Komoroske': {
    youtubeViews: 11807,
    lastUpdated: '2026-01-25',
  },
  'Alexander Embiricos': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Alisa Cohn': {
    youtubeViews: 15646,
    lastUpdated: '2026-01-25',
  },
  'Alistair Croll': {
    youtubeViews: 18073,
    lastUpdated: '2026-01-25',
  },
  'Aman Khan': {
    youtubeViews: 55200,
    lastUpdated: '2026-01-25',
  },
  'Ami Vora': {
    youtubeViews: 40981,
    lastUpdated: '2026-01-25',
  },
  'Amjad Masad': {
    youtubeViews: 34042,
    lastUpdated: '2026-01-25',
  },
  'Andrew Wilkinson': {
    youtubeViews: 58315,
    lastUpdated: '2026-01-25',
  },
  'Andy Johns': {
    youtubeViews: 11261,
    lastUpdated: '2026-01-25',
  },
  'Andy Raskin': {
    youtubeViews: 18642,
    lastUpdated: '2026-01-25',
  },
  'Anneka Gupta': {
    youtubeViews: 78977,
    lastUpdated: '2026-01-25',
  },
  'Annie Duke': {
    youtubeViews: 24269,
    lastUpdated: '2026-01-25',
  },
  'Annie Pearl': {
    youtubeViews: 7763,
    lastUpdated: '2026-01-25',
  },
  'Anton Osika': {
    youtubeViews: 56915,
    lastUpdated: '2026-01-25',
  },
  'Anuj Rathi': {
    youtubeViews: 25306,
    lastUpdated: '2026-01-25',
  },
  'Aparna Chennapragada': {
    youtubeViews: 41190,
    lastUpdated: '2026-01-25',
  },
  'April Dunford': {
    youtubeViews: 57848,
    lastUpdated: '2026-01-25',
  },
  'Archie Abrams': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Asha Sharma': {
    youtubeViews: 29724,
    lastUpdated: '2026-01-25',
  },
  'Austin Hay': {
    youtubeViews: 15429,
    lastUpdated: '2026-01-25',
  },
  'Ayo Omojola': {
    youtubeViews: 9000,
    lastUpdated: '2026-01-25',
  },
  'Bangaly Kaba': {
    youtubeViews: 28450,
    lastUpdated: '2026-01-25',
  },
  'Ben Horowitz': {
    youtubeViews: 120163,
    lastUpdated: '2026-01-25',
  },
  'Ben Mann': {
    youtubeViews: 106443,
    lastUpdated: '2026-01-25',
  },
  'Ben Williams': {
    youtubeViews: 11342,
    lastUpdated: '2026-01-25',
  },
  'Benjamin Lauzier': {
    youtubeViews: 21817,
    lastUpdated: '2026-01-25',
  },
  'Bill Carr': {
    youtubeViews: 27713,
    lastUpdated: '2026-01-25',
  },
  'Bob Baxley': {
    youtubeViews: 47355,
    lastUpdated: '2026-01-25',
  },
  'Bob Moesta': {
    youtubeViews: 19312,
    lastUpdated: '2026-01-25',
  },
  'Brandon Chu': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Brendan Foody': {
    youtubeViews: 29399,
    lastUpdated: '2026-01-25',
  },
  'Bret Taylor': {
    youtubeViews: 92047,
    lastUpdated: '2026-01-25',
  },
  'Brian Balfour': {
    youtubeViews: 38517,
    lastUpdated: '2026-01-25',
  },
  'Brian Chesky': {
    youtubeViews: 15877,
    lastUpdated: '2026-01-25',
  },
  'Brian Tolkin': {
    youtubeViews: 11223,
    lastUpdated: '2026-01-25',
  },
  'Cameron Adams': {
    youtubeViews: 25660,
    lastUpdated: '2026-01-25',
  },
  'Camille Fournier': {
    youtubeViews: 15796,
    lastUpdated: '2026-01-25',
  },
  'Camille Hearst': {
    youtubeViews: 4764,
    lastUpdated: '2026-01-25',
  },
  'Camille Ricketts': {
    youtubeViews: 12684,
    lastUpdated: '2026-01-25',
  },
  'Carilu Dietrich': {
    youtubeViews: 7660,
    lastUpdated: '2026-01-25',
  },
  'Carole Robin': {
    youtubeViews: 18605,
    lastUpdated: '2026-01-25',
  },
  'Casey Winters': {
    youtubeViews: 2246,
    lastUpdated: '2026-01-25',
  },
  'Chandra Janakiraman': {
    youtubeViews: 26769,
    lastUpdated: '2026-01-25',
  },
  'Chip Conley': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Chip Huyen': {
    youtubeViews: 40540,
    lastUpdated: '2026-01-25',
  },
  'Chris Hutchins': {
    youtubeViews: 2800,
    lastUpdated: '2026-01-25',
  },
  'Christian Idiodi': {
    youtubeViews: 24176,
    lastUpdated: '2026-01-25',
  },
  'Christina Wodtke': {
    youtubeViews: 33992,
    lastUpdated: '2026-01-25',
  },
  'Christine Itwaru': {
    youtubeViews: 9040,
    lastUpdated: '2026-01-25',
  },
  'Christopher Lochhead': {
    youtubeViews: 17271,
    lastUpdated: '2026-01-25',
  },
  'Christopher Miller': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Claire Butler': {
    youtubeViews: 29144,
    lastUpdated: '2026-01-25',
  },
  'Claire Hughes Johnson': {
    youtubeViews: 5194,
    lastUpdated: '2026-01-25',
  },
  'Claire Vo': {
    youtubeViews: 29609,
    lastUpdated: '2026-01-25',
  },
  'Dalton Caldwell': {
    youtubeViews: 262520,
    lastUpdated: '2026-01-25',
  },
  'Dan Hockenmaier': {
    youtubeViews: 32879,
    lastUpdated: '2026-01-25',
  },
  'Dan Shipper': {
    youtubeViews: 82839,
    lastUpdated: '2026-01-25',
  },
  'Daniel Lereya': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'David DeSanto': {
    youtubeViews: 13400,
    lastUpdated: '2026-01-25',
  },
  'David Placek': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'David Singleton': {
    youtubeViews: 40261,
    lastUpdated: '2026-01-25',
  },
  'Deb Liu': {
    youtubeViews: 20187,
    lastUpdated: '2026-01-25',
  },
  'Denise Tilles': {
    youtubeViews: 24418,
    lastUpdated: '2026-01-25',
  },
  'Dhanji R. Prasanna': {
    youtubeViews: 31714,
    lastUpdated: '2026-01-25',
  },
  'Dharmesh Shah': {
    youtubeViews: 72297,
    lastUpdated: '2026-01-25',
  },
  'Dmitry Zlokazov': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Donna Lichaw': {
    youtubeViews: 11734,
    lastUpdated: '2026-01-25',
  },
  'Dr. Fei Fei Li': {
    youtubeViews: 143698,
    lastUpdated: '2026-01-25',
  },
  'Drew Houston': {
    youtubeViews: 72952,
    lastUpdated: '2026-01-25',
  },
  'Dylan Field': {
    youtubeViews: 200092,
    lastUpdated: '2026-01-25',
  },
  'Ebi Atawodi': {
    youtubeViews: 6368,
    lastUpdated: '2026-01-25',
  },
  'Edwin Chen': {
    youtubeViews: 51693,
    lastUpdated: '2026-01-25',
  },
  'Eeke de Milliano': {
    youtubeViews: 13650,
    lastUpdated: '2026-01-25',
  },
  'Eilon Reshef': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Elena Verna': {
    youtubeViews: 94953,
    lastUpdated: '2026-01-25',
  },
  'Eli Schwartz': {
    youtubeViews: 88244,
    lastUpdated: '2026-01-25',
  },
  'Elizabeth Stone': {
    youtubeViews: 221166,
    lastUpdated: '2026-01-25',
  },
  'Emilie Gerber': {
    youtubeViews: 10224,
    lastUpdated: '2026-01-25',
  },
  'Emily Kramer': {
    youtubeViews: 12791,
    lastUpdated: '2026-01-25',
  },
  'Eoghan McCabe': {
    youtubeViews: 49168,
    lastUpdated: '2026-01-25',
  },
  'Eric Ries': {
    youtubeViews: 64843,
    lastUpdated: '2026-01-25',
  },
  'Eric Simons': {
    youtubeViews: 25371,
    lastUpdated: '2026-01-25',
  },
  'Ethan Smith': {
    youtubeViews: 114700,
    lastUpdated: '2026-01-25',
  },
  'Evan LaPointe': {
    youtubeViews: 16365,
    lastUpdated: '2026-01-25',
  },
  'Ezinne Udezue': {
    youtubeViews: 17466,
    lastUpdated: '2026-01-25',
  },
  'Farhan Thawar': {
    youtubeViews: 23639,
    lastUpdated: '2026-01-25',
  },
  'Garrett Lord': {
    youtubeViews: 15424,
    lastUpdated: '2026-01-25',
  },
  'Gaurav Misra': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Geoff Charles': {
    youtubeViews: 54621,
    lastUpdated: '2026-01-25',
  },
  'Geoffrey Moore': {
    youtubeViews: 27875,
    lastUpdated: '2026-01-25',
  },
  'Georgiana Laudi': {
    youtubeViews: 8844,
    lastUpdated: '2026-01-25',
  },
  'Gergely Orosz': {
    youtubeViews: 13373,
    lastUpdated: '2026-01-25',
  },
  'Gibson Biddle': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Gina Gotthilf': {
    youtubeViews: 16037,
    lastUpdated: '2026-01-25',
  },
  'Gokul Rajaram': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Graham Weaver': {
    youtubeViews: 46708,
    lastUpdated: '2026-01-25',
  },
  'Grant Lee': {
    youtubeViews: 42629,
    lastUpdated: '2026-01-25',
  },
  'Guillermo Rauch': {
    youtubeViews: 37151,
    lastUpdated: '2026-01-25',
  },
  'Gustaf Alströmer': {
    youtubeViews: 129533,
    lastUpdated: '2026-01-25',
  },
  'Gustav Söderström': {
    youtubeViews: 15996,
    lastUpdated: '2026-01-25',
  },
  'Hamel Husain': {
    youtubeViews: 83900,
    lastUpdated: '2026-01-25',
  },
  'Hamilton Helmer': {
    youtubeViews: 21273,
    lastUpdated: '2026-01-25',
  },
  'Hari Srinivasan': {
    youtubeViews: 7251,
    lastUpdated: '2026-01-25',
  },
  'Heidi Helfand': {
    youtubeViews: 5041,
    lastUpdated: '2026-01-25',
  },
  'Hila Qu': {
    youtubeViews: 15025,
    lastUpdated: '2026-01-25',
  },
  'Hilary Gridley': {
    youtubeViews: 15912,
    lastUpdated: '2026-01-25',
  },
  'Howie Liu': {
    youtubeViews: 28941,
    lastUpdated: '2026-01-25',
  },
  'Ian McAllister': {
    youtubeViews: 85092,
    lastUpdated: '2026-01-25',
  },
  'Inbal Shani': {
    youtubeViews: 10003,
    lastUpdated: '2026-01-25',
  },
  'Itamar Gilad': {
    youtubeViews: 14904,
    lastUpdated: '2026-01-25',
  },
  'Ivan Zhao': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Jackie Bavaro': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Jackson Shuttleworth': {
    youtubeViews: 29123,
    lastUpdated: '2026-01-25',
  },
  'Jag Duggal': {
    youtubeViews: 36426,
    lastUpdated: '2026-01-25',
  },
  'Jake Knapp': {
    youtubeViews: 14540,
    lastUpdated: '2026-01-25',
  },
  'Jason Droege': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Jason Feifer': {
    youtubeViews: 3838,
    lastUpdated: '2026-01-25',
  },
  'Jason Fried': {
    youtubeViews: 63007,
    lastUpdated: '2026-01-25',
  },
  'Jason Lemkin': {
    youtubeViews: 55354,
    lastUpdated: '2026-01-25',
  },
  'Jason Shah': {
    youtubeViews: 5864,
    lastUpdated: '2026-01-25',
  },
  'Jay Baxter': {
    youtubeViews: 8805,
    lastUpdated: '2026-01-25',
  },
  'Jeanne Grosser': {
    youtubeViews: 59132,
    lastUpdated: '2026-01-25',
  },
  'Jeff Weinstein': {
    youtubeViews: 45640,
    lastUpdated: '2026-01-25',
  },
  'Jeffrey Pfeffer': {
    youtubeViews: 165177,
    lastUpdated: '2026-01-25',
  },
  'Jen Abel': {
    youtubeViews: 45593,
    lastUpdated: '2026-01-25',
  },
  'Jeremy Henrickson': {
    youtubeViews: 7510,
    lastUpdated: '2026-01-25',
  },
  'Jerry Colonna': {
    youtubeViews: 14033,
    lastUpdated: '2026-01-25',
  },
  'Jessica Hische': {
    youtubeViews: 9849,
    lastUpdated: '2026-01-25',
  },
  'Jessica Lachs': {
    youtubeViews: 30211,
    lastUpdated: '2026-01-25',
  },
  'Jessica Livingston': {
    youtubeViews: 22360,
    lastUpdated: '2026-01-25',
  },
  'Jiaona Zhang': {
    youtubeViews: 19113,
    lastUpdated: '2026-01-25',
  },
  'Joe Hudson': {
    youtubeViews: 27140,
    lastUpdated: '2026-01-25',
  },
  'John Cutler': {
    youtubeViews: 14858,
    lastUpdated: '2026-01-25',
  },
  'John Mark Nickels': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'John Zeratsky': {
    youtubeViews: 14540,
    lastUpdated: '2026-01-25',
  },
  'Jonathan Becker': {
    youtubeViews: 464,
    lastUpdated: '2026-01-25',
  },
  'Jonathan Lowenhar': {
    youtubeViews: 13200,
    lastUpdated: '2026-01-25',
  },
  'Jonny Miller': {
    youtubeViews: 12829,
    lastUpdated: '2026-01-25',
  },
  'Josh Miller': {
    youtubeViews: 15024,
    lastUpdated: '2026-01-25',
  },
  'Judd Antin': {
    youtubeViews: 48638,
    lastUpdated: '2026-01-25',
  },
  'Jules Walter': {
    youtubeViews: 10305,
    lastUpdated: '2026-01-25',
  },
  'Julia Schottenstein': {
    youtubeViews: 3594,
    lastUpdated: '2026-01-25',
  },
  'Julian Shapiro': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Julie Zhuo': {
    youtubeViews: 49724,
    lastUpdated: '2026-01-25',
  },
  'Karina Nguyen': {
    youtubeViews: 22909,
    lastUpdated: '2026-01-25',
  },
  'Karri Saarinen': {
    youtubeViews: 39991,
    lastUpdated: '2026-01-25',
  },
  'Katie Dill': {
    youtubeViews: 68580,
    lastUpdated: '2026-01-25',
  },
  'Kayvon Beykpour': {
    youtubeViews: 18233,
    lastUpdated: '2026-01-25',
  },
  'Keith Coleman': {
    youtubeViews: 8805,
    lastUpdated: '2026-01-25',
  },
  'Ken Norton': {
    youtubeViews: 6140,
    lastUpdated: '2026-01-25',
  },
  'Kenneth Berger': {
    youtubeViews: 13016,
    lastUpdated: '2026-01-25',
  },
  'Kevin Weil': {
    youtubeViews: 203494,
    lastUpdated: '2026-01-25',
  },
  'Kevin Yien': {
    youtubeViews: 26144,
    lastUpdated: '2026-01-25',
  },
  'Kim Scott': {
    youtubeViews: 46535,
    lastUpdated: '2026-01-25',
  },
  'Kiriti Badam': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Kristen Berman': {
    youtubeViews: 12181,
    lastUpdated: '2026-01-25',
  },
  'Krithika Shankarraman': {
    youtubeViews: 62948,
    lastUpdated: '2026-01-25',
  },
  'Kunal Shah': {
    youtubeViews: 127250,
    lastUpdated: '2026-01-25',
  },
  'Lane Shackleton': {
    youtubeViews: 11320,
    lastUpdated: '2026-01-25',
  },
  'Laura Modi': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Laura Schaffer': {
    youtubeViews: 9073,
    lastUpdated: '2026-01-25',
  },
  'Lauren Ipsen': {
    youtubeViews: 9027,
    lastUpdated: '2026-01-25',
  },
  'Luc Levesque': {
    youtubeViews: 6811,
    lastUpdated: '2026-01-25',
  },
  'Lulu Cheng Meservey': {
    youtubeViews: 2525,
    lastUpdated: '2026-01-25',
  },
  'Madhavan Ramanujam': {
    youtubeViews: 46790,
    lastUpdated: '2026-01-25',
  },
  'Maggie Crowley': {
    youtubeViews: 43362,
    lastUpdated: '2026-01-25',
  },
  'Manik Gupta': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Maor Shlomo': {
    youtubeViews: 153586,
    lastUpdated: '2026-01-25',
  },
  'Marc Benioff': {
    youtubeViews: 78392,
    lastUpdated: '2026-01-25',
  },
  'Marily Nika': {
    youtubeViews: 72042,
    lastUpdated: '2026-01-25',
  },
  'Marty Cagan': {
    youtubeViews: 227626,
    lastUpdated: '2026-01-25',
  },
  'Matt Abrahams': {
    youtubeViews: 52599,
    lastUpdated: '2026-01-25',
  },
  'Matt Dixon': {
    youtubeViews: 19924,
    lastUpdated: '2026-01-25',
  },
  'Matt LeMay': {
    youtubeViews: 27674,
    lastUpdated: '2026-01-25',
  },
  'Matt MacInnis': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Matt Mochary': {
    youtubeViews: 2150,
    lastUpdated: '2026-01-25',
  },
  'Matt Mullenweg': {
    youtubeViews: 11106,
    lastUpdated: '2026-01-25',
  },
  'Matthew Dicks': {
    youtubeViews: 58361,
    lastUpdated: '2026-01-25',
  },
  'Maya Prohovnik': {
    youtubeViews: 3804,
    lastUpdated: '2026-01-25',
  },
  'Mayur Kamat': {
    youtubeViews: 12261,
    lastUpdated: '2026-01-25',
  },
  'Megan Cook': {
    youtubeViews: 14811,
    lastUpdated: '2026-01-25',
  },
  'Melanie Perkins': {
    youtubeViews: 49278,
    lastUpdated: '2026-01-25',
  },
  'Melissa Perri': {
    youtubeViews: 29375,
    lastUpdated: '2026-01-25',
  },
  'Melissa Tan': {
    youtubeViews: 12111,
    lastUpdated: '2026-01-25',
  },
  'Meltem Kuran Berkowitz': {
    youtubeViews: 33128,
    lastUpdated: '2026-01-25',
  },
  'Merci Grace': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Michael Margolis': {
    youtubeViews: 24205,
    lastUpdated: '2026-01-25',
  },
  'Michael Truell': {
    youtubeViews: 122323,
    lastUpdated: '2026-01-25',
  },
  'Mihika Kapoor': {
    youtubeViews: 94614,
    lastUpdated: '2026-01-25',
  },
  'Mike Krieger': {
    youtubeViews: 102963,
    lastUpdated: '2026-01-25',
  },
  'Mike Maples, Jr.': {
    youtubeViews: 53389,
    lastUpdated: '2026-01-25',
  },
  'Molly Graham': {
    youtubeViews: 25610,
    lastUpdated: '2026-01-25',
  },
  'Nabeel S. Qureshi': {
    youtubeViews: 23373,
    lastUpdated: '2026-01-25',
  },
  'Nan Yu': {
    youtubeViews: 39780,
    lastUpdated: '2026-01-25',
  },
  'Nancy Duarte': {
    youtubeViews: 32192,
    lastUpdated: '2026-01-25',
  },
  'Naomi Gleit': {
    youtubeViews: 41866,
    lastUpdated: '2026-01-25',
  },
  'Naomi Ionita': {
    youtubeViews: 15262,
    lastUpdated: '2026-01-25',
  },
  'Nesrine Changuel': {
    youtubeViews: 25895,
    lastUpdated: '2026-01-25',
  },
  'Nick Turley': {
    youtubeViews: 185089,
    lastUpdated: '2026-01-25',
  },
  'Nickey Skarstad': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Nicole Forsgren': {
    youtubeViews: 15605,
    lastUpdated: '2026-01-25',
  },
  'Nikhyl Singhal': {
    youtubeViews: 73743,
    lastUpdated: '2026-01-25',
  },
  'Nikita Bier': {
    youtubeViews: 340183,
    lastUpdated: '2026-01-25',
  },
  'Nikita Miller': {
    youtubeViews: 6027,
    lastUpdated: '2026-01-25',
  },
  'Nilan Peiris': {
    youtubeViews: 13946,
    lastUpdated: '2026-01-25',
  },
  'Nir Eyal': {
    youtubeViews: 30167,
    lastUpdated: '2026-01-25',
  },
  'Noah Weiss': {
    youtubeViews: 10351,
    lastUpdated: '2026-01-25',
  },
  'Noam Lovinsky': {
    youtubeViews: 14108,
    lastUpdated: '2026-01-25',
  },
  'Oji Udezue': {
    youtubeViews: 17466,
    lastUpdated: '2026-01-25',
  },
  'Paige Costello': {
    youtubeViews: 11321,
    lastUpdated: '2026-01-25',
  },
  'Patrick Campbell': {
    youtubeViews: 21895,
    lastUpdated: '2026-01-25',
  },
  'Paul Adams': {
    youtubeViews: 25259,
    lastUpdated: '2026-01-25',
  },
  'Paul Millerd': {
    youtubeViews: 33118,
    lastUpdated: '2026-01-25',
  },
  'Pete Kazanjy': {
    youtubeViews: 24308,
    lastUpdated: '2026-01-25',
  },
  'Peter Deng': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Petra Wille': {
    youtubeViews: 9716,
    lastUpdated: '2026-01-25',
  },
  'Phyl Terry': {
    youtubeViews: 45995,
    lastUpdated: '2026-01-25',
  },
  'Raaz Herzberg': {
    youtubeViews: 31479,
    lastUpdated: '2026-01-25',
  },
  'Rachel Lockett': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Rahul Vohra': {
    youtubeViews: 35544,
    lastUpdated: '2026-01-25',
  },
  'Raiza Martin': {
    youtubeViews: 65891,
    lastUpdated: '2026-01-25',
  },
  'Ramesh Johari': {
    youtubeViews: 44851,
    lastUpdated: '2026-01-25',
  },
  'Ravi Mehta': {
    youtubeViews: 35953,
    lastUpdated: '2026-01-25',
  },
  'Ray Cao': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Richard Rumelt': {
    youtubeViews: 96962,
    lastUpdated: '2026-01-25',
  },
  'Robby Stein': {
    youtubeViews: 27238,
    lastUpdated: '2026-01-25',
  },
  'Roger Martin': {
    youtubeViews: 113607,
    lastUpdated: '2026-01-25',
  },
  'Rohini Pandhi': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Ronny Kohavi': {
    youtubeViews: 69835,
    lastUpdated: '2026-01-25',
  },
  'Rory Sutherland': {
    youtubeViews: 170595,
    lastUpdated: '2026-01-25',
  },
  'Ryan J. Salva': {
    youtubeViews: 3800,
    lastUpdated: '2026-01-25',
  },
  'Ryan Singer': {
    youtubeViews: 29837,
    lastUpdated: '2026-01-25',
  },
  'Sachin Kansal': {
    youtubeViews: 15209,
    lastUpdated: '2026-01-25',
  },
  'Sachin Monga': {
    youtubeViews: 5417,
    lastUpdated: '2026-01-25',
  },
  'Sahil Mansuri': {
    youtubeViews: 13773,
    lastUpdated: '2026-01-25',
  },
  'Sam Lessin': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Sam Schillace': {
    youtubeViews: 16197,
    lastUpdated: '2026-01-25',
  },
  'Sanchan Saxena': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Sander Schulhoff': {
    youtubeViews: 79799,
    lastUpdated: '2026-01-25',
  },
  'Sarah Tavel': {
    youtubeViews: 17526,
    lastUpdated: '2026-01-25',
  },
  'Scott Belsky': {
    youtubeViews: 6582,
    lastUpdated: '2026-01-25',
  },
  'Scott Wu': {
    youtubeViews: 19930,
    lastUpdated: '2026-01-25',
  },
  'Sean Ellis': {
    youtubeViews: 38499,
    lastUpdated: '2026-01-25',
  },
  'Sebastian Barrios': {
    youtubeViews: 13984,
    lastUpdated: '2026-01-25',
  },
  'Seth Godin': {
    youtubeViews: 38013,
    lastUpdated: '2026-01-25',
  },
  'Shaun Clowes': {
    youtubeViews: 17591,
    lastUpdated: '2026-01-25',
  },
  'Shreya Shankar': {
    youtubeViews: 83900,
    lastUpdated: '2026-01-25',
  },
  'Shreyas Doshi': {
    youtubeViews: 8896,
    lastUpdated: '2026-01-25',
  },
  'Shweta Shrivastava': {
    youtubeViews: 5252,
    lastUpdated: '2026-01-25',
  },
  'Sri Batchu': {
    youtubeViews: 8383,
    lastUpdated: '2026-01-25',
  },
  'Sriram': {
    youtubeViews: 3258,
    lastUpdated: '2026-01-25',
  },
  'Stewart Butterfield': {
    youtubeViews: 38875,
    lastUpdated: '2026-01-25',
  },
  'Susan Cain': {
    youtubeViews: 15996,
    lastUpdated: '2026-01-25',
  },
  'Tamar Yehoshua': {
    youtubeViews: 26613,
    lastUpdated: '2026-01-25',
  },
  'Tanguy Crusson': {
    youtubeViews: 18868,
    lastUpdated: '2026-01-25',
  },
  'Teresa Torres': {
    youtubeViews: 53879,
    lastUpdated: '2026-01-25',
  },
  'Tim Holley': {
    youtubeViews: 6831,
    lastUpdated: '2026-01-25',
  },
  'Timothy Davis': {
    youtubeViews: 19287,
    lastUpdated: '2026-01-25',
  },
  'Tobi Lütke': {
    youtubeViews: 95269,
    lastUpdated: '2026-01-25',
  },
  'Todd Jackson': {
    youtubeViews: 79037,
    lastUpdated: '2026-01-25',
  },
  'Tom Conrad': {
    youtubeViews: 10032,
    lastUpdated: '2026-01-25',
  },
  'Tomer Cohen': {
    youtubeViews: 24125,
    lastUpdated: '2026-01-25',
  },
  'Tristan de Montebello': {
    youtubeViews: 39317,
    lastUpdated: '2026-01-25',
  },
  'Upasna Gautam': {
    youtubeViews: 2698,
    lastUpdated: '2026-01-25',
  },
  'Uri Levine': {
    youtubeViews: 10229,
    lastUpdated: '2026-01-25',
  },
  'Varun Mohan': {
    estimatedPopularity: 0.5,
    lastUpdated: '2026-01-25',
  },
  'Varun Parmar': {
    youtubeViews: 13097,
    lastUpdated: '2026-01-25',
  },
  'Vijay Iyengar': {
    youtubeViews: 8137,
    lastUpdated: '2026-01-25',
  },
  'Vikrama Dhiman': {
    youtubeViews: 138149,
    lastUpdated: '2026-01-25',
  },
  'Vlad Loktev': {
    youtubeViews: 15858,
    lastUpdated: '2026-01-25',
  },
  'Wes Kao': {
    youtubeViews: 23839,
    lastUpdated: '2026-01-25',
  },
  'Will Larson': {
    youtubeViews: 36705,
    lastUpdated: '2026-01-25',
  },
  'Yuhki Yamashita': {
    youtubeViews: 31866,
    lastUpdated: '2026-01-25',
  },
  'Yuriy Timen': {
    youtubeViews: 10015,
    lastUpdated: '2026-01-25',
  },
  'Zoelle Egner': {
    youtubeViews: 7186,
    lastUpdated: '2026-01-25',
  },
};

/**
 * Get popularity score for a guest (0-1 normalized)
 */
export function getGuestPopularity(guestName: string): number {
  const data = episodePopularity[guestName];
  if (!data) return 0.5;

  if (data.youtubeViews !== undefined) {
    const minViews = 5000;
    const maxViews = 400000;
    const views = Math.max(minViews, Math.min(maxViews, data.youtubeViews));
    const logMin = Math.log10(minViews);
    const logMax = Math.log10(maxViews);
    const logViews = Math.log10(views);
    return (logViews - logMin) / (logMax - logMin);
  }

  if (data.estimatedPopularity !== undefined) {
    return data.estimatedPopularity;
  }

  return 0.5;
}

export function hasPopularityData(guestName: string): boolean {
  return guestName in episodePopularity;
}

export function getGuestsWithPopularity(): string[] {
  return Object.keys(episodePopularity);
}